/** @format */
import { createSlice } from "@reduxjs/toolkit";
import { IPractitioner } from "lobbie";
import { addPractitioners, setPractitioners } from "../actions/practitionerActions";

// TODO: Practitioners Reducer is a bare array
export type PractitionersState = IPractitioner[];

const initialState: PractitionersState = [];

const practitionerSlice = createSlice({
    name: "practitionersSlice",
    initialState,
    reducers: {},
    extraReducers: (builder) =>
        builder
            .addCase(addPractitioners, (state, action) => [...state.concat(action.payload ?? [])])
            .addCase(setPractitioners, (_, action) => [...(action.payload ?? [])]),
});

export default practitionerSlice;
